import React from 'react'

const ErrorBox = ({messages}) => {
    const hasMessages = _.find(messages, message => { return false !== message })

    if(hasMessages) {
        return (
            <div className="error-box">
                <h5>Folgende Fehler sind aufgetreten:</h5>

                <ul>
                    {messages.map((message, index) => {
                        if(false !== message) {
                            return <li key={index}>{message}</li>
                        }
                    })}
                </ul>
                
            </div>
        )
    } else {
        return ''
    }
}

export default ErrorBox